
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MasterMasterGroupsFundosService } from './master-master-groups-fundos.service';
import { Funds } from '../consulta-fundos/master-consulta-fundos.models';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SharedVariable } from '@app/custom-shared/util/shared-variable';
import { MatPaginator } from '@angular/material/paginator';
/**
* This Component manages the presentation logic of Edit screen
*
*/
@Component({
  selector: 'app-master-master-groups-fundos',
  templateUrl: './master-master-groups-fundos.component.html',
  styleUrls: ['./master-master-groups-fundos.scss']
})
export class MasterMasterGroupsFundosComponent implements OnInit {

  funds: any;
  displayedColumns: string[] = ["code", "name"];
  sorted: boolean = false;
  showLoading: boolean = true;
  filterAutoComplete: Array<any>;
  fundsComplete: any;
  dialogConfig: any;
  @Input()
  name: string;
  @Input()
  id: string;

  @ViewChild('sortFunds', { static: false }) sortFunds: MatSort;
  @ViewChild('paginator') paginator: MatPaginator;

  fundsFilter: any;
  constructor(
    private shared : SharedVariable,
    private _masterFundsService: MasterMasterGroupsFundosService,
    private activatedRoute: ActivatedRoute
  ) {
  }

  ngOnInit() {
    this.getFunds();
  }

  async getFunds() {
    const payload = { id: this.id };
    let result = await this._masterFundsService.getInvestmentGroups(payload);
    
    this.shared.resultUsers = result
    result.funds = result.funds.filter(el => {
      return el.checked == true
    });

    result['funds'].map((u) => u.code);

    this.funds = new MatTableDataSource<Funds>(result['funds'].naturalSort(['code']));

    this.funds.sortingDataAccessor = (data, sortHeaderId) => {
      return data[sortHeaderId].naturalNormalize();
    }
    this.funds.sort = this.sortFunds;
    this.funds.paginator = this.paginator;
    this.showLoading = false


  }

  filterFunds(event: Event) {
    this.funds.filterPredicate = (data, filter) => {
      if (data.code === null || data.code === undefined) {
        data.code = ''
      }
      if (data.name === null || data.name === undefined) {
        data.name = ''
      }
      return data.code.toLowerCase().includes(filter.toLowerCase()) || data.name.toLowerCase().includes(filter.toLowerCase());
    }
    this.fundsFilter = (event.target as HTMLInputElement).value;
    this.funds.filter = this.fundsFilter;

    if (this.fundsFilter.length > 0 && this.fundsFilter.length % 2 == 0) {
      this.fundsComplete = this.funds.filteredData;
    } else if (this.fundsFilter.length == 0) {
      this.fundsComplete = []
    }
  }

}
